module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '87cn4ian',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
